<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card max-width="600" grid-list-lg>
      <ModelTitle title="Receive Payment" @close="close()" />

      <v-card-text>
        <v-container class="pa-0" grid-list-lg>
          <v-card-text>
            <v-layout row wrap justify-space-between>
              <v-flex xs6 v-if="CustomerId">
                <div>Customer ID</div>
                <div class="font-weight-medium title">
                  {{ Customer.localId }}
                </div>
              </v-flex>
              <v-flex xs6 v-else>
                <div>Customer ID</div>
                <div class="font-weight-medium title">
                  {{ Customer.id }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div>Balance</div>
                <div class="font-weight-medium title">
                  {{ Customer.balance | currency }}
                </div>
              </v-flex>
              <v-flex xs8>
                <div>Customer Name</div>
                <div class="font-weight-medium title text-capitalize">
                  {{ Customer.name }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div>Paying</div>
                <div class="font-weight-medium title">
                  {{ total | currency }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap justify-space-between>
              <v-flex xs12 sm4>
                <DateSelector label="Payment Date" v-model="Payment.date" />
              </v-flex>

              <v-flex xs12 sm4>
                <v-select dense outlined :items="paymentMethods" v-model="Payment.paymentMethod" label="Payment Method"
                  item-text="name" hide-details return-object></v-select>
              </v-flex>

              <v-flex xs12 sm4>
                <v-text-field type="number" dense outlined class="right-input" hide-details label="Total Payment"
                  @focus="$event.target.select()" v-model="InvoiceTotal"></v-text-field>
              </v-flex>

              <!-- <v-flex xs12 sm3>
                
              </v-flex> -->
              <v-flex xs12>
                <v-text-field dense outlined v-model="Payment.note" label="Memo" hide-details></v-text-field>
              </v-flex>

            </v-layout>
            <v-layout row wrap align-center v-if="Customer && Customer.payCompassId">
              <v-flex xs6>
                <v-checkbox class="ma-0 pa-0" v-model="collectedOnline" label="Collect Online" color="red"
                  :value="false" hide-details> </v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="collectedOnline">
                <v-select item-text="last4" return-object v-model="selectedCard" :loading="loadingCard" outlined dense
                  hide-details :items="cards" label="Select Card">
                  <template slot="item" slot-scope="{ item }">
                    <span>{{ item.last4 }}</span>
                    <v-spacer></v-spacer>
                    <span class="text-capitalize">{{ item.payment_method_type
                      }}</span>
                  </template></v-select>
              </v-flex>
            </v-layout>
            <div class="text-center mt-3">
              <span>Balance: {{ balance | currency }}/ Total:
                {{ InvoiceTotal | currency }}/ Payment Receiving:
                {{ total | currency }}</span>
            </div>
          </v-card-text>
          <v-card :color="color" :disabled="InvoiceTotal === 0" outlined v-if="Invoice">
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs7>
                  <v-select clearable dense outlined :items="Invoice" hide-details label="Select Invoice"
                    item-text="localId" return-object v-model="selectedInvoice">
                    <template slot="item" slot-scope="{ item }">
                      <span>{{ item.localId }}</span>
                      <v-spacer></v-spacer>
                      <span>{{ item.due | currency }}</span>
                    </template>
                    <template v-slot:append-item v-if="Invoice.length !== 0">
                      <v-divider class="mt-2"></v-divider>
                      <v-list-item @click="payAll">
                        <v-list-item-content>
                          <v-list-item-title>Receive All</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                          {{ InvoiceTotal | currency }}
                        </v-list-item-icon>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs3>
                  <v-text-field type="number" dense outlined class="right-input" hide-details label="Payment"
                    @focus="$event.target.select()" v-model="amount"></v-text-field>
                </v-flex>
                <v-flex shrink>
                  <v-btn @click="add" color="success"> add </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-list class="list-250">
            <template v-for="(row, index) in Payment.PaymentDetails">
              <v-list-item :key="row.id">
                <v-list-item-avatar>
                  <v-btn icon text color="red" @click="remove(index)"><v-icon>delete</v-icon></v-btn>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ row.localId }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <span class="title">{{ row.amount | currency }}</span>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < Payment.PaymentDetails.length" :key="index">
              </v-divider>
            </template>
          </v-list>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-checkbox class="ma-0" v-model="Payment.donation" label="Donation Payment" color="red" :value="false"
          hide-details>
        </v-checkbox>
        <v-spacer></v-spacer>
        <v-btn color="info" text @click="close()">Close</v-btn>
        <v-btn color="info" :disabled="Payment.PaymentDetails.length === 0" :loading="loading" @click="submit()">{{
    total
    | currency }} Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceService from "@/modules/Invoice/service";
import customerService from "@/modules/Customer/service";
import donorService from "@/modules/Donors/service.js";
import paymentService from "../service";
import payCompassService from "@/modules/PayCompass/service.js";
import DateSelector from "@/components/DateSelector";

export default {
  name: "create-payment",
  props: {
    createDialog: {
      default: false,
    },
    CustomerId: {
      default: null,
    },
    DonorId: {
      default: null,
    },
  },
  components: {
    DateSelector,
  },
  data() {
    return {
      collectResult: null,
      collectedOnline: false,
      InvoiceTotal: 0,
      loadingCard: false,
      selectedInvoice: null,
      Invoice: null,
      loading: false,
      dialog: false,
      amount: 0,
      Customer: {
        name: null,
        balance: 0,
        localId: null,
      },
      cards: [],
      selectedCard: null,
      paymentMethods: [
        'Stripe',
        'Mohid',
        "Cash",
        "Check",
        "Paypal",
        "Debit Card",
        "Credit Card",
        "Wire",
        "Quick Pay",
        "Cash App",
        "Exchange",
        "Zelle",
        "Other",
      ],
      Payment: {
        CustomerId: 0,
        date: this.$moment().toISOString(),
        paymentMethod: "Stripe",
        PaymentDetails: [],
        mohidId: null,
        stripeId: null,
        donation: false
      },
    };
  },
  computed: {
    color() {
      let value = "indigo lighten-5";
      if (this.balance === 0) {
        value = "green lighten-5";
      } else {
        if (this.balance < 0) {
          value = "red lighten-5";
        } else {
          value = "indigo lighten-5";
        }
      }

      return value;
    },
    total() {
      let value = 0;
      this.Payment.PaymentDetails.map((row) => {
        value += parseFloat(row.amount);
      });

      return value;
    },
    balance() {
      return this.InvoiceTotal - parseFloat(this.total);
    },
  },
  watch: {
    collectedOnline(val) {
      if (val) {
        this.getCard(this.Customer.payCompassId)
        this.Payment.date = this.$moment().toISOString()
      }
    },
    selectedInvoice(val) {
      if (this.balance > val.due) {
        this.amount = val.due;
      } else {
        if (this.balance <= 0) {
          this.amount = val.due;
        } else {
          this.amount = this.balance;
        }
      }
    },

    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.loadOpenInvoice();
        this.getCustomer();
      }
    },
  },
  methods: {
    getCard(id) {
      payCompassService.getAllCard(id).then(response => {
        console.log('response', response)
        this.cards = response.data
        if (this.cards.length === 1) {
          this.selectedCard = this.cards[0]
        }
      })
    },
    async payAll() {
      this.$swal({
        title: "Are you sure?",
        text: `You want to select all the invoices for ${this.$options.filters.currency(
          this.InvoiceTotal
        )}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.value) {
          await Promise.all(
            this.Invoice.map((row) => {
              let x = row;
              x.amount = row.due;
              x.InvoiceId = row.id;
              row.donation = this.Payment.donation || false
              this.Payment.PaymentDetails.push(row);
            })
          );
          this.Invoice = [];
          this.emptybar();
        }
      });
    },
    add() {
      if (this.amount === 0) return false;
      const index = this.Invoice.findIndex(
        (x) => x.id === this.selectedInvoice.id
      );
      let row = this.Invoice[index];

      if (this.amount > this.Invoice[index].due) {
        this.$swal({
          title: "Exceeded!",
          text: `Payment can't be more then ${this.Invoice[index].due}`,
          icon: "warning",
        });
      } else {
        row.amount = this.amount;
        row.InvoiceId = row.id;
        row.donation = this.Payment.donation
        this.Payment.PaymentDetails.push(row);
        this.Invoice.splice(index, 1);
        this.amount = 0;
        // this.selectedInvoice = null
      }
    },
    emptybar() {
      this.amount = 0;
      this.selectedInvoice = null;
    },
    remove(i) {
      this.Invoice.push(this.Payment.PaymentDetails[i]);
      this.Payment.PaymentDetails.splice(i, 1);
    },
    async getCustomer() {

      if (this.CustomerId) {
        this.Customer = (await customerService.getById(this.CustomerId)).data
      } else {
        this.Customer = (await donorService.getById(this.DonorId)).data
      }

      console.log('this.Customer ', this.CustomerId, this.DonorId, this.Customer)

      if (!this.Customer) {
        console.log('customer not found')
        return false
      }

      if (this.CustomerId) {
        this.Payment.CustomerId = this.Customer.id;
      } else {
        this.Payment.DonorId = this.Customer.id;
      }

      if (this.Customer?.mohidId) {
          this.Payment.mohidId = this.Customer.mohidId
          this.Payment.paymentMethod = 'Mohid'
        }
        if (this.Customer?.stripeId) {
          this.Payment.stripeId = this.Customer.stripeId
          this.Payment.paymentMethod = 'Stripe'
        }

      // return customerService.getById(id).then((response) => {
      //   console.log('response', response)
      //   this.Customer = response.data;

        
      //   // this.Payment.CustomerId = this.Customer.id;

        
      //   return response;
      // });

    },
    loadOpenInvoice() {
      this.loading = true;
      let where = {
        due: true,
      }
      if (this.CustomerId) {
        where.CustomerId = this.CustomerId
      } else {
        where.DonorId = this.DonorId
      }
      console.log('where', where)
      return invoiceService
        .getAll(where)
        .then((response) => {
          this.loading = false;
          this.Invoice = response.data;
          this.InvoiceTotal = 0
          this.Invoice.map((row) => {
            this.InvoiceTotal += row.due;
          });
          return response;
        });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.InvoiceTotal = 0;
      this.collectedOnline = false
      this.card = []
      this.Payment = {
        CustomerId: 0,
        date: this.$moment().toISOString(),
        paymentMethod: "Cash",
        PaymentDetails: [],
        mohidId: null,
        stripeId: null
      };
    },
    savePayment() {
      return paymentService
        .create(this.Payment)
        .then((result) => {
          // this.$events.emit("CustomerMiniList");
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Payment was made",
              });
            this.loading = false;
            this.empty();
            this.$emit("submit");
            this.$events.emit("paymentListEvent");
            this.$events.emit("customerProfileEvent");
            this.$events.emit("invoiceListEvent");
            this.close();
          }
        })
        .catch((err) => {
          console.log("jerror", err);
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
    async collectPayment() {
      try {
        let amount = 0
        let description = 'Invoice # '
        this.Payment.PaymentDetails.map(row => {
          amount += row.amount
          description = description + row.localId + ', ' + row.id + ', '
        })
        let chargeObj = {
          amount: amount,
          description: description,
          source: this.selectedCard.id,
          customer: this.Customer.payCompassId,
          cardId: this.selectedCard.id,
          selectedInvoice: this.Payment.PaymentDetails
        }
        console.log('chargeObj', chargeObj)
        const paymentResponse = await payCompassService.chargeCustomerForMultipleInvoice(chargeObj)
        console.log('response payment', paymentResponse)
        if (paymentResponse && paymentResponse.data && paymentResponse.data.status_code === 'A') {
          this.Payment.referenceNumber = `${this.selectedCard.payment_method_type}-${this.selectedCard.last4}`
          this.Payment.PaymentDetails.map(row => {
            row.stripeChargeId = paymentResponse.data.reference_number
            row.metadata = paymentResponse.data
            // amount += row.amount
            // description = description + row.localId + ', ' + row.id + ', '
          })
          // this.Payment.PaymentDetails[0].stripeChargeId = paymentResponse.data.reference_number
          this.Payment.donation = false
          this.Payment.parent = true
          // this.Payment.PaymentDetails[0].metadata = paymentResponse.data
          return paymentResponse
        } else {
          this.$swal(response.data.status, response.data.error_message, 'error')
          this.loadingBtn = false
          return false
        }
      } catch (error) {
        console.log('error', error)
        this.loadingBtn = false
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.data.message,
          });
        return false
      }


    },
    async submit() {
      this.$swal({
        title: "Saving Payment",
        text: `You are receiving ${this.$options.filters.currency(
          this.total
        )}? `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.value) {
          console.log('payment', this.Payment)
          if (this.collectedOnline) {
            this.collectResult = await this.collectPayment()
            console.log('this.collectResult', this.collectResult)
            if (this.collectResult) {
              this.savePayment()
            }
          } else {
            this.savePayment()
          }
        }
      });

    },
  },
};
</script>

<style scoped></style>
